/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WithdrawalRequestResponseItem } from './withdrawal-request-response-item';


export interface WithdrawalRequestResponseItemPagedList { 
    totalCount?: number;
    items?: Array<WithdrawalRequestResponseItem> | null;
}

